// @flow
import React, { useEffect, useContext } from 'react';
import { Button, Alert, Col, Row, Container } from 'react-bootstrap';
import { Redirect, Link, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { UserContext } from '../../contexts/UserContext';

import { VerticalForm, FormInput } from '../../components/';
import AccountLayout from './AccountLayout';

const BottomLink = () => {
  return (
    <Container>
      <Row className="mt-3">
        <Col className="text-center">
          <p className="text-muted">
            Don't have an account?
            <Link to={'/account/register'} className="text-muted ms-1" style={{ cursor: 'pointer' }}>
              <b>Register here</b>
            </Link>
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <p className="text-muted" id="verify-div" style={{ display: 'none' }}>
            <button id="verify-btn" style={{ backgroundColor: 'transparent', border: 'none', padding: '0', fontWeight: '700', color: 'inherit' }}>Click here</button> to send a new verification email
          </p>
        </Col>
      </Row>
    </Container>
  );
};

const Login = (props): React$Element<any> => {
  const { search } = useLocation();
  const url = new URLSearchParams(search);
  const r = url.get('r');
  const { user, error, loginUser, isLoggedIn, userLoading } = useContext(UserContext);

  useEffect(() => {
    if (user) {
      if (props.location.state && props.location.state.from)
        props.history.replace(props.location.state.from);
      else
        props.history.push('/');
    }
  }, [user]);

  /*
  form validation schema
  */
  const schemaResolver = yupResolver(
    yup.object().shape({
      email: yup.string().email('Please enter a valid email address').required('Please enter your email').max(100),
      password: yup.string().required('Please enter your password').max(255)/* .min(6) */,
    })
  );

  /*
  handle form submission
  */
  const onSubmit = (formData) => {
    loginUser(formData['email'], formData['password']);
  };

  // useEffect(() => {
  //     //reset auth
  //     logoutUser();
  // }, []);

  return (
    <>
      {isLoggedIn() ? <Redirect to="/" /> : (
        <AccountLayout bottomLinks={<BottomLink />}>
          <div className="">
            <h4 className="text-dark-50 mt-0 mb-4 fw-bold fs-2 text-start ps-0 ms-0">{'Sign in'}</h4>
          </div>

          {error && (
            <Alert variant="danger" className="my-2">
              {error}
            </Alert>
          )}

          <VerticalForm
            onSubmit={onSubmit}
            resolver={schemaResolver}>
            <FormInput
              className='py-2'
              label='Email'
              type="email"
              name="email"
              placeholder='Enter your email'
              containerClass='mb-3'
            />
            <FormInput
              className='py-2'
              label='Password'
              type="password"
              name="password"
              placeholder='Enter your password'
              containerClass='mb-1'>
            </FormInput>

            <Link to={`/account/forgotpassword?r=${r ?? 'c'}`} className="text-muted float-center">
              <small>{'Forgot your password?'}</small>
            </Link>

            <div className="mb-3 mt-3 mb-0 text-center">
              <Button style={{ borderRadius: '36px' }} variant="primary" className='w-100 py-2' type="submit" disabled={userLoading}>
                {'Log in'}
              </Button>
            </div>
            <div className="text-muted my-4 text-center">
              Having trouble logging in? <br />
              Email us at: <a href="mailto:hi@errands.nyc" className='text-muted'><b>hi@errands.nyc</b></a>
            </div>
          </VerticalForm>
        </AccountLayout>
      )
      }
    </>
  );
};

export default Login;
